import { useState } from 'react'

export function Header() {
  const [imageError, setImageError] = useState(false)

  return (
    <header className="h-[50px] bg-primary shadow-md sticky top-0 z-40">
      <div className="h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-full">
          {/* Title */}
          <h1 className="text-xl sm:text-2xl font-semibold" style={{ color: '#ffffff' }}>
            RSUI Payment Portal
          </h1>

          {/* Right side - Logo */}
          <div className="flex items-center">
            {!imageError && (
              <img
                src="/images/RSUI-Logo-White.png"
                alt="RSUI"
                className="h-10 w-auto"
                onError={() => setImageError(true)}
              />
            )}
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
